module.exports = __webpack_public_path__ + "img/die-detector-api.3b03369e.png";